import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import { ReactComponent as DeleteGroup } from '../../../../assets/images/remove.svg';
import ActionEditButton from './ActionEditButton';
import { chracterPosition } from '../../../../utils/index';
import { colorCodesForAvatar } from '../../../../constants/index';

function EditGroupTable(props) {
  const { groupData, deleteUserHandler } = props;
  const [isLoading, setIsLoading] = useState(!groupData?.length); // ⬅️ Skeleton visible initially

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);

  // When groupData loads, hide skeleton
  React.useEffect(() => {
    if (groupData && groupData.length > 0) {
      setIsLoading(false);
    }
  }, [groupData]);

  return (
    <div>
      <table className="Team-main-table-container">
        <thead>
          <tr className="table-header-cell">
            <th>{t.NAMETB}</th>
            <th>{t.ROLETB}</th>
            <th>{t.PIRORITY}</th>
          </tr>
        </thead>

        <tbody className="tbodyClass01">
          {isLoading ? (
            // 🦴 Skeleton rows while loading
            [...Array(4)].map((_, index) => (
              <tr key={index} className="team-table-tr">
                <td>
                  <div className="team-table-img" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <div className="team-table-nameEmail">
                      <Skeleton variant="text" width={120} height={18} />
                      <Skeleton variant="text" width={160} height={14} />
                    </div>
                  </div>
                </td>
                <td>
                  <Skeleton variant="text" width={80} height={18} />
                </td>
                <td>
                  <Skeleton variant="rectangular" width={60} height={24} />
                </td>
                <td>
                  <Skeleton variant="circular" width={24} height={24} />
                </td>
              </tr>
            ))
          ) : groupData.length > 0 ? (
            // ✅ Actual table rows
            groupData.map((row) => (
              <tr key={row.id} className="team-table-tr">
                <td>
                  <div className="team-table-img">
                    <p>
                      {row.agent_image ? (
                        <Avatar
                          src={row.agent_image}
                          alt="users logo"
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                          }}
                        />
                      ) : (
                        <Avatar
                          sx={{
                            bgcolor:
                              colorCodesForAvatar[
                              chracterPosition(
                                row.name.substring(0, 1).toUpperCase(),
                              )
                              ],
                          }}
                        >
                          {row.name.substring(0, 1).toUpperCase()}
                        </Avatar>
                      )}
                    </p>
                    <div className="team-table-nameEmail">
                      <p>{row.name}</p>
                      <p>{row.email}</p>
                    </div>
                  </div>
                </td>

                <td style={{ textTransform: 'capitalize' }}>{row.role_name}</td>
                <td>
                  <ActionEditButton />
                </td>
                <td>
                  {row.role_name !== 'admin_with_billing' && (
                    <p
                      className="groupIcon"
                      style={{ cursor: 'pointer' }}
                      onClick={deleteUserHandler}
                    >
                      <DeleteGroup />
                    </p>
                  )}
                </td>
              </tr>
            ))
          ) : (
            // 🕳️ Empty state (optional)
            <tr>
              <td colSpan="4" style={{ textAlign: 'center', padding: '16px', color: '#999' }}>
                No members found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default EditGroupTable;
